import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { GenresAutocompleteComponent } from './genres-autocomplete.component';

@Component({
  selector: 'ctv-genres-autocomplete-chips',
  template: `
    <div class="ctv-genres-autocomplete-chips-wrapper">
      <ctv-genres-autocomplete #ec [activeGenres]="activeGenres" [availableGenres]="availableGenres" (genreSelected)="onItemSelected($event)" [formFieldClass]="formFieldClass">
      </ctv-genres-autocomplete>
      <mat-chip-list #chipList [ngClass]="stacked ? 'mat-chip-list-stacked' : ''" [hidden]="items.length < 1">
        <mat-basic-chip *ngFor="let item of items"
                        [removable]="true"
                        (removed)="remove(item)">
          {{item}}
          <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
        </mat-basic-chip>
      </mat-chip-list>
    </div>
  `,
})
export class GenresAutocompleteChipsComponent implements OnInit {

  @ViewChild(GenresAutocompleteComponent, {static: true}) ec: GenresAutocompleteComponent;

  @Input()
  public placeholder: string;

  @Input()
  public stacked: false;

  @Input()
  public activeGenres: string[];

  @Input()
  public availableGenres: string[];

  @Input()
  public availableGenresFlag: boolean;

  @Input()
  public formFieldClass: string;

  @Output()
  genreSelectionChange = new EventEmitter<string[]>();

  items: string[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.items = this.activeGenres;
    if (this.availableGenresFlag) {
      this.ec.availableGenresFlag = this.availableGenresFlag;
    }
  }

  onItemSelected($event: string) {
    if ($event && !this.items.find(x => x === $event)) {
      this.items.push($event);
      this.genreSelectionChange.emit(this.items);
    }
    this.ec.resetInput();
    this.ec.updateFilteredGenres(this.items);
  }

  remove(e: string) {
    this.items.splice(this.items.indexOf(e), 1);
    this.genreSelectionChange.emit(this.items);
    this.ec.updateFilteredGenres(this.items);
  }
}
